import { render, staticRenderFns } from "./AttachmentsTab.vue?vue&type=template&id=6b0163fa&scoped=true&"
import script from "./AttachmentsTab.vue?vue&type=script&lang=js&"
export * from "./AttachmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsTab.vue?vue&type=style&index=0&id=6b0163fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0163fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VCard,VCardText,VFileInput})
